import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { AppActionCreators, IApplicationState, IVxmAnalysisDetailReportResponse, ReportActionCreators } from '@nkr/store/index';
import { IMatchOffer } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { Button, FormControl, Glyphicon, Label } from 'react-bootstrap';
import { downloadFile } from '@nkr/services/download-file';
import Grid from './grid';

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getVxmAnalysisDetailReport: (centerId: number, csv: boolean) => Promise<IVxmAnalysisDetailReportResponse>,
    getVxmAnalysisDetailReportExport: (centerId: number, csv: boolean) => Promise<IVxmAnalysisDetailReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: IMatchOffer[],
    centerId: number,
    startDate: string,
    endDate: string
}

class VxmAnalysisDetailReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        centerId: 0,
        startDate: '',
        endDate: ''
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report, one moment please...').then(() => {
            this.props.getVxmAnalysisDetailReport(this.props.centerId, false).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let { reportData: list, startDate, endDate } = response.data.results;

                    this.setState({
                        list,
                        startDate,
                        endDate
                    });
                }
            });
        });
    }

    getCenterList = () => {
        let list = this.state.list.map(x => {
            return { id: x.recipientCenterId, alias: x.recipientCenter };
        });

        let centers = _.uniqBy(list, item => item.id);

        return _.sortBy(centers, item => item.alias);
    }

    getFilteredList = () => {
        return this.state.list.filter(x => {
            let centerFilter = this.state.centerId > 0 ? x.donorCenterId == this.state.centerId : true;

            return centerFilter;
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleExport = () => {
        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getVxmAnalysisDetailReportExport(this.props.centerId, true)
                .then(response => {
                    downloadFile(response.data, `vxm-accuracy-details-last-3-months-export`, 'text/csv');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    render = () => {
        const centerList = this.getCenterList();
        const filteredList = this.getFilteredList();

        return (
            <div style={{ minHeight: 500, paddingLeft: this.props.isCenterLogin ? 10 : 0, paddingRight: this.props.isCenterLogin ? 10 : 0 }}>
                {this.props.isCenterLogin == false ?
                    <>
                        <div style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                            <div style={{ fontSize: 28, fontWeight: 500 }}>VXM Accuracy Details ({this.state.startDate} - {this.state.endDate})</div>
                        </div>

                        <div className='well well-sm' style={{ display: "flex", justifyContent: 'space-between' }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5 }}>Filter by Center:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {centerList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>

                            <div>
                                <Button onClick={this.handleExport}>Export CSV</Button>
                            </div>

                        </div>
                    </>
                    :
                    <div style={{ marginBottom: 10 }}>Report date range: <Label style={{ fontSize: '90%' }}>{this.state.startDate}</Label> - <Label style={{ fontSize: '90%' }}>{this.state.endDate}</Label></div>
                }

                {/* <TableWrapper condensed striped>
                    <thead>
                        <tr>
                            <th colSpan={3}>Recipient</th>
                            <th colSpan={2}>Donor</th>
                            <th rowSpan={2}>Offer</th>
                            <th rowSpan={2}>Deadline</th>
                            <th rowSpan={2}>Decision</th>
                            <th colSpan={3}>Accepted</th>
                            <th colSpan={4}>Declined</th>
                            <th rowSpan={2}>No<br />Response</th>
                        </tr>
                        <tr>
                            <th>Center</th>
                            <th>Alias</th>
                            <th>NKR cPRA</th>
                            <th>Alias</th>
                            <th>Center</th>

                            <th>No Issues</th>
                            <th>Not Confident</th>
                            <th>Not Confident<br />&gt; 99% NKR cPRA</th>

                            <th>Unacceptable</th>
                            <th>Unacceptable<br />&gt; 99% NKR cPRA</th>
                            <th>Surgeon<br />Unavailable</th>
                            <th>Other</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.map((item, index) =>
                            <tr key={'rexm-' + index}>
                                <td>{item.recipientCenter}</td>
                                <td>{item.recipientAlias}</td>
                                <td>{item.recipientCpra4.toFixed(2)}</td>
                                <td>{item.donorAlias}</td>
                                <td>{item.donorCenter}</td>
                                <td>{item.offerDateTime}</td>
                                <td>{item.deadlineDateTime}</td>
                                <td>{item.decisionDateTime}</td>

                                <td>{item.wasAcceptedNoIssues || item.wasAcceptedNoIssuesAbove99Cpra ? <Glyphicon glyph='ok' /> : null}</td>
                                <td>{item.wasAcceptedNotConfident ? <Glyphicon glyph='ok' /> : null}</td>
                                <td>{item.wasAcceptedNotConfidentAbove99Cpra ? <Glyphicon glyph='ok' /> : null}</td>

                                <td>{item.wasDeclinedUnacceptable ? <Glyphicon glyph='ok' /> : null}</td>
                                <td>{item.wasDeclinedUnacceptableAbove99Cpra ? <Glyphicon glyph='ok' /> : null}</td>
                                <td>{item.wasDeclinedSurgeonUnavailable ? <Glyphicon glyph='ok' /> : null}</td>
                                <td>{item.wasDeclinedOther ? <Glyphicon glyph='ok' /> : null}</td>

                                <td>{item.decisionDateTime == '' ? <Glyphicon glyph='ok' /> : null}</td>
                            </tr>
                        )}

                        {filteredList.length == 0 && (
                            <tr>
                                <td colSpan={16}>No match offers found for last 3 months...</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper> */}

                <Grid data={filteredList} />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        // reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getVxmAnalysisDetailReport: (centerId) => {
            return dispatch(ReportActionCreators.getVxmAnalysisDetailReport(centerId, false));
        },
        getVxmAnalysisDetailReportExport: (centerId) => {
            return dispatch(ReportActionCreators.getVxmAnalysisDetailReport(centerId, true));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(VxmAnalysisDetailReport);